"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ClientLog = _interopRequireWildcard(require("../ClientLog"));
var _TicketLog = _interopRequireDefault(require("../TicketLog"));
var _LogListSkeleton = _interopRequireDefault(require("../LogListSkeleton"));
var _LogSkeleton = _interopRequireDefault(require("../LogSkeleton"));
var _InfiniteList = _interopRequireDefault(require("../../../../../InfiniteList"));
var _constants = require("../../../../../../constants");
var _excluded = ["logs", "relateTo", "hasNextPage", "selectedCallId", "onEdit", "onPin", "onFlag", "onDelete", "onClickIcon", "onReasonDelete", "onReasonSubmit", "threshold"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PAGE_SIZE_DEFAULT = 20;
var THRESHOLD_DEFAULT = 5;
var defaultProps = {
  hasNextPage: false,
  isNextPageLoading: false,
  threshold: THRESHOLD_DEFAULT,
  minimumBatchSize: PAGE_SIZE_DEFAULT
};
var LogList = /*#__PURE__*/function (_React$PureComponent) {
  function LogList(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, LogList);
    _this = _callSuper(this, LogList, [props]);
    _this.listRef = void 0;
    _this.renderCount = void 0;
    _this.listRef = /*#__PURE__*/_react["default"].createRef();
    _this.renderCount = 0;
    _this.handleScrollLock = _this.handleScrollLock.bind(_this);
    _this.handleLoadPage = _this.handleLoadPage.bind(_this);
    _this.isItemLoaded = _this.isItemLoaded.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(LogList, _React$PureComponent);
  return (0, _createClass2["default"])(LogList, [{
    key: "handleScrollLock",
    value: function handleScrollLock(_ref) {
      var communicationBottom = _ref.communicationBottom,
        preventScroll = _ref.preventScroll;
      var listElement = this.listRef.current;
      if (listElement) {
        listElement.style.overflow = preventScroll ? 'hidden' : 'overlay';
        var _listElement$getBound = listElement.getBoundingClientRect(),
          listBottom = _listElement$getBound.bottom;
        var elDiff = listBottom - communicationBottom;
        var bottomOffset = 10;
        if (elDiff < 0) {
          listElement.scrollTop += Math.abs(elDiff) + bottomOffset;
        }
      }
    }
  }, {
    key: "handleLoadPage",
    value: function handleLoadPage(startIndex, stopIndex) {
      var isNextPageLoading = this.props.isNextPageLoading;
      if (isNextPageLoading) {
        return;
      }
      var onLoadRequest = this.props.onLoadRequest;
      onLoadRequest(startIndex, stopIndex);
    }
  }, {
    key: "getItemCount",
    value: function getItemCount() {
      var _this$props = this.props,
        logs = _this$props.logs,
        hasNextPage = _this$props.hasNextPage;
      return hasNextPage ? (0, _size2["default"])(logs) + 1 : (0, _size2["default"])(logs);
    }
  }, {
    key: "isItemLoaded",
    value: function isItemLoaded(index) {
      var logs = this.props.logs;
      return (0, _has2["default"])(logs, "".concat(index, ".id"));
    }
  }, {
    key: "emptyRenderer",
    value: function emptyRenderer() {
      var isNextPageLoading = this.props.isNextPageLoading;
      return isNextPageLoading ? /*#__PURE__*/_react["default"].createElement(StyledLogListSkeleton, null) : /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, "\u041D\u0435\u0442 \u043B\u043E\u0433\u043E\u0432.");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        logs = _this$props2.logs,
        relateTo = _this$props2.relateTo,
        hasNextPage = _this$props2.hasNextPage,
        selectedCallId = _this$props2.selectedCallId,
        onEdit = _this$props2.onEdit,
        onPin = _this$props2.onPin,
        onFlag = _this$props2.onFlag,
        onDelete = _this$props2.onDelete,
        onClickIcon = _this$props2.onClickIcon,
        onReasonDelete = _this$props2.onReasonDelete,
        onReasonSubmit = _this$props2.onReasonSubmit,
        threshold = _this$props2.threshold,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      this.renderCount += 1;
      return /*#__PURE__*/_react["default"].createElement(StyledLogList, props, hasNextPage || !(0, _isEmpty2["default"])(logs) ? /*#__PURE__*/_react["default"].createElement(StyledList, {
        flexible: true,
        isItemLoaded: this.isItemLoaded,
        itemCount: this.getItemCount(),
        itemData: logs,
        itemKey: LogList.getItemKey,
        onLoadRequest: this.handleLoadPage,
        outerRef: this.listRef,
        threshold: threshold
      }, function (_ref2) {
        var data = _ref2.data,
          index = _ref2.index,
          style = _ref2.style;
        if (!_this2.isItemLoaded(index)) {
          return /*#__PURE__*/_react["default"].createElement(StyledItem, {
            style: style
          }, /*#__PURE__*/_react["default"].createElement(StyledLogSkeleton, null));
        }
        var log = data[index];
        var type = log.type;
        return /*#__PURE__*/_react["default"].createElement(StyledItem, {
          key: log.id,
          "data-id": log.id,
          style: style,
          type: type
        }, _constants.LOG_RELATIONS.CLIENT === relateTo && /*#__PURE__*/_react["default"].createElement(_ClientLog["default"], (0, _extends2["default"])({}, log, {
          selectedCallId: selectedCallId,
          onDelete: onDelete,
          onEdit: onEdit,
          onPin: onPin,
          onClickIcon: onClickIcon,
          onClickOutside: _this2.handleScrollLock,
          onReasonDelete: onReasonDelete,
          onReasonSubmit: onReasonSubmit
        })), _constants.LOG_RELATIONS.TICKET === relateTo && /*#__PURE__*/_react["default"].createElement(_TicketLog["default"], (0, _extends2["default"])({}, log, {
          onPin: onPin,
          onFlag: onFlag,
          onEdit: onEdit,
          onClickIcon: onClickIcon,
          onClickOutside: _this2.handleScrollLock
        })));
      }) : this.emptyRenderer());
    }
  }], [{
    key: "getItemKey",
    value: function getItemKey(index, logs) {
      return (0, _get2["default"])(logs, "".concat(index, ".id")) || index;
    }
  }]);
}(_react["default"].PureComponent);
LogList.defaultProps = defaultProps;
var StyledLogList = _styledComponents["default"].ul.withConfig({
  displayName: "LogList__StyledLogList",
  componentId: "sc-aa9nsl-0"
})(["background-color:#e6e6e6;height:100%;overflow:hidden;width:100%;"]);
var StyledList = (0, _styledComponents["default"])(_InfiniteList["default"]).withConfig({
  displayName: "LogList__StyledList",
  componentId: "sc-aa9nsl-1"
})(["height:100%;overflow:auto;"]);
var StyledItem = _styledComponents["default"].li.withConfig({
  displayName: "LogList__StyledItem",
  componentId: "sc-aa9nsl-2"
})(["width:calc(100% - 5px);:first-of-type ", ":before{top:13px;height:calc(100% - 13px);}:last-of-type ", ":before{height:9px;}"], _ClientLog.StyledTimeline, _ClientLog.StyledTimeline);
var StyledLogListSkeleton = (0, _styledComponents["default"])(_LogListSkeleton["default"]).withConfig({
  displayName: "LogList__StyledLogListSkeleton",
  componentId: "sc-aa9nsl-3"
})(["height:100%;margin-left:8px;margin-top:13px;"]);
var StyledLogSkeleton = (0, _styledComponents["default"])(_LogSkeleton["default"]).withConfig({
  displayName: "LogList__StyledLogSkeleton",
  componentId: "sc-aa9nsl-4"
})(["margin-left:8px;margin-top:5px;"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "LogList__StyledEmpty",
  componentId: "sc-aa9nsl-5"
})(["color:#4d4d4d;height:100%;padding-top:85px;text-align:center;"]);
var _default = exports["default"] = LogList;